import { RootState } from 'app/store'

import { IQRAScenario, IStringAttributeDetails } from './types'
import { createSelector } from '@reduxjs/toolkit'

export const selectThreatId = (state: RootState): string =>
  state.riskManagement.whatIfScenario.selectedThreatId

export const selectScenario = (state: RootState): IQRAScenario =>
  state.riskManagement.whatIfScenario.selectedScenario

export const selectStringAttributeCode = (state: RootState): string =>
  state.riskManagement.whatIfScenario.stringAttributeCode

export const selectStringAttributeDetails = (
  state: RootState
): IStringAttributeDetails[] =>
  state.riskManagement.whatIfScenario.stringAttributeDetails

export const selectScenarioForDropdowns = createSelector(
  (state: RootState) => state.riskManagement.whatIfScenario.selectedScenario,
  (selectedScenario) => {
    return { label: selectedScenario.name, value: selectedScenario.id }
  }
)
